export class UserSettings {

    navbarPinned: boolean = false;
    recentlyViewedItems: RecentlyViewed[] = [];

    constructor() {

    }

}

/* used to keep a log of the recently viewed items */
export class RecentlyViewed {

    objectId: string = '';
    name: string = '';
    type: string = '';
    summary: string = '';
    logoUrl: string = '';
    link: string = '';

    constructor(objectId: string, name: string, type: string, summary: string, logoUrl: string) {
        this.objectId = objectId;
        this.name = name;
        this.type = type;
        this.summary = summary;
        this.logoUrl = logoUrl;
        this.link = this.getLinkUrl();
    }

    getLinkUrl() {

        switch (this.type) {
            case 'Contact':
                return '/contacts';
            case 'Company':
                return '/companies';
            default:
                return '/projects';
        }
    }

}



// WEBPACK FOOTER //
// ./client/app/core/user/user-settings.model.ts